// extracted by mini-css-extract-plugin
export default {"root":"nXuZT1Pzi4C7_3wEWOdj","titleText":"EMxlbecD_wwvmQITkhq1","full":"XcIKYtRvkrv3_9ZMwMOZ","placeholderAnimate":"uvjTCiKSXNWuVaOiEdIZ"};